module.exports = __webpack_public_path__ + "img/18a-lrn-spt-cat-1-icon-def.06c2fec4.svg";